import { keyframes, styled } from 'styled-components';
import TableItem from '../../components/Table/TableItem';
import FirstTableItem from '../../components/Table/FirstTableItem';
import Input from '../../components/utils/Input/Input';
import { ReactComponent as DeleteIcon } from '../../assets/icons/delete.svg';
import { ReactComponent as EditIcon } from '../../assets/icons/edit.svg';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;
export const ButtonText = styled.span`
  user-select: none;
  font-size: 16px;
  font-family: 'Poppins-Medium';

  letter-spacing: -0.408px;
  color: ${props => (props.$black ? 'white' : 'black')};
`;
export const StyledButton = styled.button`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  justify-content: center;
  padding: 16px;
  border-radius: 12px;
  border: ${props => (props.$black ? '1px solid black' : '1px solid #be6a59')};
  background-color: ${props => (props.$black ? 'black' : 'white')};
  cursor: ${props => (props.$disabled ? 'not-allowed' : 'pointer')};
  outline: none;

  height: 54px;
  width: 160px;
  &:active {
    scale: ${props => (props.$disabled ? 1 : 0.98)};
    transition: all 0.2s ease-in-out;
  }
  @media (max-width: 500px) {
    width: 48%;
  }
`;

export const ButtonContainerGap = styled.div`
  display: flex;
  justify-content: space-between;
  @media (max-width: 500px) {
    width: 100%;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
  }
`;
export const ModalTitleSmall = styled.span`
  color: #000;
  text-align: justify;
  font-family: Playfair Display;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
`;
export const Edit = styled(EditIcon)`
  cursor: pointer;
`;
export const Delete = styled(DeleteIcon)`
  cursor: pointer;
`;
export const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  min-height: 100vh;
  background-color: #faf5f6;
  gap: 33px;
  padding-right: 33px;
  @media (max-width: 800px) {
    padding-top: 50px;
    padding-left: 33px;
  }
`;
export const ContentContainer = styled.div`
  padding-bottom: 100px;
  padding-left: 265px;
  width: 100%;
  @media (max-width: 800px) {
    padding-left: 0;
  }
`;

export const InboxContainer = styled.div`
  flex: 1;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.04);
  display: flex;
  min-height: 389px;
  flex-direction: column;
  gap: 4px;
`;
export const MessageContainer = styled.div`
  display: flex;
  width: 100%;
  padding: 12px 16px;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
`;
export const LeftSide = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;
  min-width: 42.5%;
`;
export const Name = styled.span`
  color: #000;
  font-family: 'Poppins-Medium';

  font-size: 15px;
  font-style: normal;

  line-height: normal;
  letter-spacing: -0.408px;
`;

export const Message = styled.div`
  font-size: 12px;
  font-family: 'Poppins-Medium';

  letter-spacing: -0.408px;
  text-align: left;

  min-width: 47.5%;
`;
export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
`;
export const IconContainer = styled.div`
  min-width: 5%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;
export const PaginationContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  align-items: flex-end;
  padding: 1.6rem 2.4rem;
  flex: 1;
`;

export const ModalTitle = styled.span`
  color: #000;
  text-align: justify;
  font-family: Playfair Display;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 39px; /* 162.5% */
`;
export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 24px;
`;

export const ButtonModalCancel = styled.button`
  border-radius: 16px;
  border: 1px solid #be6a59;
  display: flex;
  width: 160px;
  padding: 16px 4px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  background: white;
  cursor: pointer;

  color: #1e1e1e;
  text-align: justify;

  font-size: 16px;
  font-style: normal;
  font-family: 'Poppins-Medium';

  line-height: 22px; /* 137.5% */
  letter-spacing: -0.408px;

  &:active {
    transition: all 0.2s ease-in-out;
    scale: 0.95;
  }
`;
export const ButtonModal = styled(ButtonModalCancel)`
  background: #f1e4df;
  border: none;
`;

export const ModalButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const IconPosition = styled.div`
  position: absolute;
  top: 13px;
  right: 24px;
`;

export const ButtonAdd = styled.button`
  display: flex;
  cursor: pointer;
  padding: 16px;
  margin-top: 16px;
  justify-content: center;
  gap: 8px;
  align-items: center;
  align-self: stretch;
  border-radius: 16px;
  border: 1px solid #f3e6e1;
  background: #fcf7f6;
  width: 100%;

  color: #000;
  text-align: center;
  font-family: 'Poppins-Medium';

  font-size: 18px;
  font-style: normal;

  line-height: normal;
  letter-spacing: -0.408px;

  &:active {
    transition: all 0.2s ease-in-out;
    scale: 0.95;
  }
`;
export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
export const FirstItem = styled(FirstTableItem)`
  padding-left: 18px;
`;
export const LastTableItem = styled(TableItem)`
  padding-right: 16px;
  justify-content: flex-end;
  max-width: ${props => (props.$chevron ? '50px' : '250px')};
  min-width: ${props => (props.$chevron ? '50px' : '250px')};
  width: ${props => (props.$chevron ? '50px' : '250px')};
  cursor: pointer;
  &:active {
    opacity: 0.6;
  }
`;
export const StatusTableItem = styled.div`
  display: flex;
  width: 81px;
  padding: 2px 8px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  color: ${props => (props.$completed ? 'rgba(0, 0, 0, 0.50)' : '#6c7e75')};
  font-family: 'Poppins-Medium';
  font-size: 12px;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.408px;
  border-radius: 8px;
  background: ${props => (props.$completed ? 'rgba(0, 0, 0, 0.10)' : '#D8E2DD')};
`;

export const ModalContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;

  max-height: 950px;

  gap: 16px;
  /* max-height: calc(100% - 60px); */
  overflow: auto;
`;

export const SmallModalContainer = styled.div`
  background: white;
  width: fit-content;
  height: fit-content;
  padding: 25px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  gap: 40px;
  position: absolute;
  top: 50%;
  left: 50%;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;
  border-radius: 10px;
  transform: translate(-50%, -50%);
  animation: ${props => (props.$open ? fadeIn : fadeOut)} 0.3s ease-in-out;

  @media (max-width: 500px) {
    width: 90%;
  }
`;

export const Background = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  animation: ${props => (props.$open ? fadeIn : fadeOut)} 0.3s ease-in-out;

  bottom: 0;
  background-color: ${props => (props.$bg ? 'transparent' : 'rgba(0, 0, 0, 0.2)')};
  backdrop-filter: blur(1.3px);
  -webkit-backdrop-filter: blur(1.3px);
  width: 100%;
  border-radius: 10px;
  height: 100%;
`;
export const TemplateDetailsContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const ToDoContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
  background-color: #fcf7f6;
  padding-top: 5px;
  padding-left: 5px;
`;

export const ToDosTitle = styled.span`
  color: #000;
  font-family: 'Poppins-Medium';
  font-size: 16px;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.2px;
  opacity: 0.5;
  align-self: center;
`;

export const StyledInput = styled(Input)`
  min-width: 100%;
  border-bottom: ${props => (props.disabled ? '1px solid #e2dddb' : '1px solid black')};
  &::placeholder {
    color: black;
    opacity: ${props => (props.disabled ? 0.5 : 1)};
  }
`;

export const TextArea = styled.textarea`
  font-size: 16px;
  font-style: normal;
  font-family: 'Poppins-Medium';

  line-height: normal;
  letter-spacing: -0.2px;
  background-color: transparent;
  padding: 12px;
  border: none;
  outline: none;
  min-width: 100%;
  &::placeholder {
    color: black;
    opacity: ${props => (props.disabled ? 0.5 : 1)};
  }
  border-bottom: ${props => (props.disabled ? '1px solid #e2dddb' : '1px solid black')};
`;

export const DeleteContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  align-self: center;
  gap: 10px;
  margin-top: 25px;
  border-radius: 10px;
  padding: 12px;
  cursor: pointer;
  &:hover {
    span {
      color: #ff0000;
    }
    svg {
      path {
        stroke: #ff0000;
      }
    }
  }
`;

export const DeleteText = styled.span`
  font-family: 'Poppins-Medium';
  font-size: 16px;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.408px;
  user-select: none;
`;
